// Class: openfl.net.URLRequestDefaults

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var URLRequestDefaults = function(){}

// Meta

URLRequestDefaults.__name__ = "openfl.net.URLRequestDefaults";
URLRequestDefaults.__isInterface__ = false;
URLRequestDefaults.prototype = {
	
};
URLRequestDefaults.prototype.__class__ = URLRequestDefaults.prototype.constructor = $hxClasses["openfl.net.URLRequestDefaults"] = URLRequestDefaults;

// Init



// Statics


URLRequestDefaults.followRedirects = true
URLRequestDefaults.idleTimeout = 0
URLRequestDefaults.manageCookies = false

// Export

exports.default = URLRequestDefaults;